export class FinishDialogData {
    constructor() {
        this.data = [];
        this.properties = [];
        this.variables = {};
    }
}